import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Snackbar, Alert, IconButton } from "@mui/material";
import styles from "../css/Categoria.module.css";
import { Grid } from "@mui/system";
import { useEffect, useState } from "react";

import miAxios from "../api/axios";
import { useAuth } from "../hooks/AuthProvider";
import Confirmacion from "./Conformacion";
import Wait from "./Wait";

export default function Categoria(props) {
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [id, setId] = useState(0)
    const [descripcion, setDescripcion] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState(false)

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        if (props.open) {
            inicio(props.id)
        }
    }, [props.open])


    const inicio = async (cual) => {
        if (cual == 0) {
            setId(0)
            setDescripcion("")

        } else {
            setProcesando(true)
            try {
                const response = await axios.get("items/categoria-inicio?cual=" + cual)
                const data = response.data;
                if (data.respuesta == "S") {
                    setId(cual)
                    setDescripcion(data.datos.descripcion)
                } else {
                    setMensaje(data.mensaje)
                }
            } catch (error) {
                console.log(error)
                setMensaje(error)
            }

            setProcesando(false)
        }

    }

    const handleGrabarCategoria = () => {
        if (puedeGrabar()) {
            grabar()
        }
    }

    const puedeGrabar = () => {
        if (descripcion.length == 0) {
            setMensaje("Debe digitar la descripción")
            return false;
        }
        return true;
    }

    const grabar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)
        try {
            const response = await axios.post("items/categoria-grabar",
                {
                    id: id,
                    descripcion: descripcion
                }
            );
            const data = response.data;
            console.log(data)
            if (data.respuesta == "S") {
                props.cerrar()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    return <Dialog open={props.open} fullWidth>
        <Wait procesando={procesando} />
        <Confirmacion open={openConfirmacion} texto="¿Desea grabar esta categoría?" cancelar={() => { setOpenConfirmacion(false) }} exito={handleGrabarCategoria} />
        <Snackbar
            open={mensaje.length > 0}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setMensaje("")}
        >
            <Alert severity="error" onClose={() => setMensaje("")} variant="filled">
                {mensaje}
            </Alert>
        </Snackbar>
        <DialogTitle>
            Añadir/Editar Categoría
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={2} sx={{ paddingTop: "20px" }}>
                <Grid size={6}>
                    <TextField
                        size="small"
                        color="coopinfa"
                        label="Id"
                        value={(id==0? "(Nueva)": id)}
                        disabled
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        fullWidth
                        size="small"
                        color="coopinfa"
                        label="Descripción"
                        value={descripcion}
                        onChange={(event) => { setDescripcion(event.target.value) }}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" color="coopinfa" sx={{ minWidth: "100px" }} onClick={() => { props.cerrar() }}>Cancelar</Button>
            <Button variant="contained" color="coopinfa" sx={{ minWidth: "100px" }} onClick={() => { if (puedeGrabar()) { setOpenConfirmacion(true) } }}>Grabar</Button>
        </DialogActions>
    </Dialog>
}